/* eslint-disable */

import RaindropInput from "../raindrop-input/raindrop-input.tsx";
import { useState } from "react";
import RaindropButton from "../raindrop-button/raindrop-button.tsx";
import { fetchOrganisationDetailImagePost } from "../../services/api-raindrop";
import ModelComponent from "../model-component/model-component.tsx";
import RaindropInputFile from "../raindrop-input-file/raindrop-input-file.tsx";

const ModelComponentOrganisationDetailMedia = ({
  organisationDetailMediaId,
  caption,
  imageUrl,
  rawData = null,
}) => {
  const [localImageUrl, setLocalImageUrl] = useState(imageUrl);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [file, setFile] = useState();

  const onSubmit = () => {
    setIsSubmitting(true);

    fetchOrganisationDetailImagePost({
      organisationId: organisationId,
      file: file,
    })
      .then((response) => {
        console.log("🟢 (RD-783) - ", response);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <ModelComponent
      modelId={organisationDetailMediaId}
      colorBorderAccent="border-l-color-model-organisation-detail-media dark:border-l-color-dark-model-organisation-detail-media"
      rawData={rawData}
    >
      <RaindropInput
        label="Caption"
        placeholder="Enter organisation description"
        value={caption}
        isEditing={false}
        icon=""
        isShowLabel={true}
      />

      <RaindropInputFile
        label="Upload Media"
        imageUrl={localImageUrl}
        setImageUrl={setLocalImageUrl}
        onChange={(e) => setFile(e.target.files[0])}
      />
      <RaindropButton
        title="Save"
        icon="fa-save"
        style={ButtonStyle.Secondary}
        onClick={onSubmit}
      />
    </ModelComponent>
  );
};

export default ModelComponentOrganisationDetailMedia;
